import React, { Component } from 'react';

import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import { getBuildingCommunity } from 'actions/tenantProfileActions';

import EventAndNoticeCard from './components/eventsAndNotices/EventAndNoticeCard';
import { Card } from 'material-ui/Card';

import { colors } from 'helpers/ColorHelper';

import { Timeline } from 'react-twitter-widgets';
import { connect } from 'react-redux';

import { CSSTransitionGroup } from 'react-transition-group';

const style = {
  card: {
    color: '#424242 !important',
    fontFamily: '"Circular", sans-serif !important',
    height: '100%',
    overflow: 'hidden',
    marginTop: '15px',
  },
};

export default connect(
  store => ({
    showPage: store.authentication.showPage,
    buildingCommunity: store.tenantProfile.buildingCommunity,
  }),
  {
    getBuildingCommunity,
  }
)(
  class Community extends Component {
    UNSAFE_componentWillMount = () => {
      this.props.getBuildingCommunity();
    };

    render() {
      const url =
        '//forecast.io/embed/#lat=' +
        this.props.buildingCommunity.latitude +
        '&lon=' +
        this.props.buildingCommunity.longitude +
        '&units=ca';

      const twitterHandle = this.props.buildingCommunity
        ? this.props.buildingCommunity.twitter_handle
        : '';

      const buildingEventsAndNotices = this.props.buildingCommunity.events_and_notices
        ? this.props.buildingCommunity.events_and_notices
        : [];

      const MyMapComponent = withScriptjs(
        withGoogleMap(props => (
          <GoogleMap
            defaultZoom={16}
            defaultCenter={{
              lat: this.props.buildingCommunity.latitude,
              lng: this.props.buildingCommunity.longitude,
            }}
          >
            {props.isMarkerShown && (
              <Marker
                position={{
                  lat: this.props.buildingCommunity.latitude,
                  lng: this.props.buildingCommunity.longitude,
                }}
              />
            )}
          </GoogleMap>
        ))
      );

      const eventsAndNotices = buildingEventsAndNotices.map((eventAndNotice, index) => {
        return (
          <EventAndNoticeCard
            key={index}
            eventAndNotice={eventAndNotice}
            openPromotionDialog={this.togglePromotionDialog}
          />
        );
      });

      return (
        <div
          className="body"
          role="main"
          ref="buildingContainer"
          style={{ backgroundColor: '#fdfdfd', borderLeft: '1px solid #f7f7f7' }}
        >
          {this.props.showPage && (
            <div className="centers">
              <div style={{ padding: '0 10px' }}>
                <h2 style={{ margin: '0 0 15px 0' }}>Local Community</h2>
                <div style={{ maxWidth: '1300px', margin: 'auto' }}>
                  <div className="col-sm-8">
                    <div style={{ maxWidth: '600px', margin: 'auto' }}>
                      <div>{eventsAndNotices}</div>
                      {eventsAndNotices.length === 0 && (
                        <Card style={style.card}>
                          <h5
                            style={{
                              textAlign: 'center',
                              color: colors.GRAY,
                              fontFamily: 'Circular',
                              padding: '30px 15px',
                              margin: 0,
                            }}
                          >
                            There are currently no posted events or promotions. Check back here
                            frequently to be the first in the know.
                          </h5>
                        </Card>
                      )}
                      <div style={{ height: '100px' }} />
                    </div>
                  </div>
                  <div className="col-sm-4" style={{ maxWidth: '350px', margin: 'auto' }}>
                    <CSSTransitionGroup
                      transitionName="show_weather"
                      transitionEnterTimeout={500}
                      transitionLeaveTimeout={500}
                    >
                      {this.props.buildingCommunity.latitude && (
                        <div
                          className="row"
                          style={{ overflow: 'hidden', maxWidth: '300px', margin: 'auto' }}
                        >
                          <iframe
                            title="weather"
                            type="text/html"
                            frameBorder="0"
                            src={url}
                            style={{
                              width: '100%',
                              height: '225px',
                              top: '10',
                              marginTop: '-35px',
                              marginLeft: '-15px',
                            }}
                          />
                        </div>
                      )}
                    </CSSTransitionGroup>
                    {twitterHandle && (
                      <div className="row">
                        <Timeline
                          dataSource={{
                            sourceType: 'profile',
                            screenName: this.props.buildingCommunity.twitter_handle,
                          }}
                          options={{
                            username: this.props.buildingCommunity.twitter_handle,
                            height: '400',
                          }}
                        />
                      </div>
                    )}
                    <div className="row">
                      <div style={{ marginTop: '30px' }}>
                        <MyMapComponent
                          isMarkerShown
                          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBbplKGGLQIm9NFREVZ54QHlrbLGVzXDec&v=3.exp&libraries=geometry,drawing,places"
                          loadingElement={<div style={{ height: `100%` }} />}
                          containerElement={<div style={{ height: `400px` }} />}
                          mapElement={<div style={{ height: `100%` }} />}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ height: '100px' }} />
              </div>
            </div>
          )}
        </div>
      );
    }
  }
);
